import { Router } from 'vue-router'

export function createPageFromGuard(router: Router) {
  router.beforeEach(() => {})

  router.afterEach((to, from) => {
    // 记录上一页路径 用于匹配菜单选中
    to.meta.from = from.fullPath
    setTimeout(() => {}, 200)
  })

  router.onError(() => {})
}
